import { render, staticRenderFns } from "./bulletinBoard.vue?vue&type=template&id=57e52cde&scoped=true"
import script from "./bulletinBoard.vue?vue&type=script&lang=js"
export * from "./bulletinBoard.vue?vue&type=script&lang=js"
import style0 from "./bulletinBoard.vue?vue&type=style&index=0&id=57e52cde&prod&lang=less&scoped=true"
import style1 from "./bulletinBoard.vue?vue&type=style&index=1&id=57e52cde&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e52cde",
  null
  
)

export default component.exports